import PeriodSelection from "@/components/helpers/PeriodSelection";
import { useForm } from "@soft-db/form";
import { useRefObjectSync } from "@soft-db/soft-utils";
import { SoftSwitch } from "@soft-db/ui";
import { PropType } from "vue";
import { CommentBoxOptions, defaultCommentBoxOptions } from "./comment-box-options";

export default defineComponent({
	props: {
		modelValue: {
			type: Object as PropType<CommentBoxOptions>,
			default: () => defaultCommentBoxOptions,
		},
	},
	setup(props) {
		const { t } = useI18n();

		const valueModel = useVModel(props, "modelValue");
		const period = useRefObjectSync(valueModel, "period");
		const alignPeriod = useRefObjectSync(valueModel, "alignPeriod");

		const { useField, handleSubmit } = useForm<CommentBoxOptions>({ mode: "immediate" });
		const periodField = useField("period", {
			isNumber: true,
			isRequired: true,
			min: 1,
			initialValue: period.value,
		});

		const saveChanges = handleSubmit((options) => (period.value = options.period));

		return () => (
			<>
				<PeriodSelection
					class="mx-4 mt-2"
					label={t("common.period")}
					v-model={periodField.data.value}
					required
					onUpdate:modelValue={saveChanges}
				/>
				<SoftSwitch class="m-4" label={t("dashboard.alignPeriod")} v-model={alignPeriod.value} />
			</>
		);
	},
});
